// extracted by mini-css-extract-plugin
export var divider = "Kpis-module--divider--21867";
export var kpis = "Kpis-module--kpis--c310d";